import { useQueryClient } from 'react-query'
import { useStrategy } from '../../hooks/useStrategy'
import { LinkingItemsIds, LinkingItemType } from '../../../components/Linking/Linking.types'

const useInvalidateLinkingQueries = () => {
    const queryClient = useQueryClient()

    const { _id: strategyId } = useStrategy()

    const invalidateLinkedItemsQuery = (id: string, linkingType: LinkingItemType) => {
        return queryClient.removeQueries(['linkedItems', id, linkingType])
    }

    const createInvalidationQueries = (itemsIds: LinkingItemsIds) => {
        const invalidationQueries = []
        ;(Object.keys(itemsIds) as LinkingItemType[]).forEach((linkingType) => {
            itemsIds[linkingType].forEach((id) => {
                invalidationQueries.push(invalidateLinkedItemsQuery(id, linkingType))
            })
        })

        return invalidationQueries
    }

    const invalidateLinkingQueries = async () => {
        queryClient.removeQueries(['linkedItems'])
        queryClient.removeQueries(['linkableItems', strategyId])
    }

    return { createInvalidationQueries, invalidateLinkedItemsQuery, invalidateLinkingQueries }
}

export default useInvalidateLinkingQueries
